import React, { FC, Key, useEffect, useState } from 'react'
import './AppraisalLog.scss'
import { Link } from 'react-router-dom'
import { appraisalService } from 'Services/appraisalService'
import { HorizontalLoader } from 'Components'
import { Logger } from 'Helpers/Logger'
import { AppraisalsMGRType, AppraisalsType } from 'Models/appraisalsType'
import { TimeConverter } from 'Helpers/TimeConverter'
import { setQuarter } from 'date-fns'

export type AppraisalsSettingsFormType = {
  appraisalOpen: boolean
  appraisalQuarter: string
  appraisalYear: number
}

const AppraisalLog: FC<{ showEmployeeAppraisal?: (val: boolean) => void }> = ({
  showEmployeeAppraisal,
}) => {
  const [pageNumber, setPage] = useState(1)
  const [year, setYear] = useState<string>()
  const [quarter, setQuarter] = useState<number>()

  const [appraisal, setAppraisals] = useState<AppraisalsMGRType[]>()
  const [loading, setLoading] = useState(false)

  const [paginationData, setPaginationData] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 1,
  })

  const getApraisals = async () => {
    setLoading(true)
    await appraisalService.managerIndex(year, quarter).then(
      (response) => {
        setLoading(false)
        // console.log('ap response', response)
        setAppraisals(response?.data.data)
        showEmployeeAppraisal && showEmployeeAppraisal(response?.data.data.length > 0)
      },
      (error: { response: object }) => {
        setLoading(false)
        Logger('response error', error.response)
      },
    )
  }

  useEffect(() => {
    getApraisals()
  }, [pageNumber, year, quarter])

  return (
    <div className='AppraisalLog'>
      <div className='container mt-4'>
        <div className='container'>
          <div className='card border-0'>
            <div className='card-header border-0 px-0 h-100'>
              <div className='row h-100'>
                <div className='col-12 col-md-6 my-auto h-100 d-flex pe-md-0'>
                  <div className='wraper  my-auto'>
                    <div className='title my-auto'>All Employees Appraisals</div>
                    <select
                      className='form-control ms-3'
                      onChange={(val) => setYear(val.target.value)}
                    >
                      <option value={''}>All Year</option>
                      <option>2024</option>
                      <option>2025</option>
                      <option>2026</option>
                      <option>2027</option>
                      <option>2028</option>
                      <option>2029</option>
                      <option>2030</option>
                      <option>2031</option>
                      <option>2032</option>
                      <option>2033</option>
                      <option>2034</option>
                      <option>2035</option>
                    </select>
                    <select
                      className='form-control ms-3'
                      onChange={(val) => setQuarter(Number(val.target.value))}
                    >
                      <option value={''}>All Quarter</option>
                      <option value={1}>Q1</option>
                      <option value={2}>Q2</option>
                      <option value={3}>Q3</option>
                      <option value={4}>Q4</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className='card-body'>
              <div className='table-responsive'>
                <table className='table'>
                  <thead>
                    <tr>
                      {/* <td>Employee ID</td> */}
                      <td>S/N</td>
                      <td>Year</td>
                      <td>Quarter</td>
                      <td>Employee</td>
                      <td>Date</td>
                      <td>Status</td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    {appraisal &&
                      appraisal?.length > 0 &&
                      appraisal.map((data: AppraisalsMGRType, index: Key) => (
                        <tr key={index}>
                          {/* <td>{data.userId}</td> */}
                          <td>{Number(index) + 1}</td>
                          <td>{data.year}</td>
                          <td>Q{data.quarter}</td>
                          <td>
                            {data.employee.firstName} {data.employee.lastName}
                          </td>
                          <td>{TimeConverter(data.createdAt)}</td>
                          <td>
                            {data.status === 'AWAITING_LINE_MANAGER_REVIEW' ? (
                              <span className='status-warn'>{data.status}</span>
                            ) : (
                              <span className='status-success'>{data.status}</span>
                            )}
                          </td>
                          <td className='dropdown option-dropdown d-inline-flex'>
                            {data.status === 'AWAITING_LINE_MANAGER_REVIEW' && (
                              <Link to={`/appraisal-log/${data.id}/${data.employee.id}`}>
                                <button className='btn btn-default-outline border'>
                                  <svg
                                    width='18'
                                    height='18'
                                    viewBox='0 0 18 18'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                  >
                                    <path
                                      d='M8.99945 12.2479C7.20695 12.2479 5.75195 10.7929 5.75195 9.00043C5.75195 7.20793 7.20695 5.75293 8.99945 5.75293C10.792 5.75293 12.247 7.20793 12.247 9.00043C12.247 10.7929 10.792 12.2479 8.99945 12.2479ZM8.99945 6.87793C7.82945 6.87793 6.87695 7.83043 6.87695 9.00043C6.87695 10.1704 7.82945 11.1229 8.99945 11.1229C10.1695 11.1229 11.122 10.1704 11.122 9.00043C11.122 7.83043 10.1695 6.87793 8.99945 6.87793Z'
                                      fill='#82858A'
                                    />
                                    <path
                                      d='M9.00055 15.7654C6.18055 15.7654 3.51805 14.1154 1.68805 11.2504C0.893047 10.0129 0.893047 7.99535 1.68805 6.75035C3.52555 3.88535 6.18805 2.23535 9.00055 2.23535C11.813 2.23535 14.4755 3.88535 16.3055 6.75035C17.1005 7.98785 17.1005 10.0054 16.3055 11.2504C14.4755 14.1154 11.813 15.7654 9.00055 15.7654ZM9.00055 3.36035C6.57805 3.36035 4.26055 4.81535 2.64055 7.35785C2.07805 8.23535 2.07805 9.76535 2.64055 10.6429C4.26055 13.1854 6.57805 14.6404 9.00055 14.6404C11.423 14.6404 13.7405 13.1854 15.3605 10.6429C15.923 9.76535 15.923 8.23535 15.3605 7.35785C13.7405 4.81535 11.423 3.36035 9.00055 3.36035Z'
                                      fill='#82858A'
                                    />
                                  </svg>
                                  View
                                </button>
                              </Link>
                            )}
                            <button
                              className='btn border-0 dropdown-toggle d-none'
                              data-bs-toggle='dropdown'
                              aria-expanded='false'
                              data-bs-popper-config='{"strategy":"fixed"}'
                            >
                              <svg
                                width='18'
                                height='18'
                                viewBox='0 0 18 18'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M7.49991 8.4705C7.49991 7.72933 8.0955 7.14697 8.82344 7.14697C9.55138 7.14697 10.147 7.74256 10.147 8.4705C10.147 9.19844 9.55138 9.79403 8.82344 9.79403C8.0955 9.79403 7.49991 9.21168 7.49991 8.4705Z'
                                  fill='#707070'
                                />
                                <path
                                  d='M7.49991 14.1175C7.49991 13.3763 8.0955 12.7939 8.82344 12.7939C9.55138 12.7939 10.147 13.3895 10.147 14.1175C10.147 14.8454 9.55138 15.441 8.82344 15.441C8.0955 15.441 7.49991 14.8587 7.49991 14.1175Z'
                                  fill='#707070'
                                />
                                <path
                                  d='M7.49991 2.82353C7.49991 2.08235 8.0955 1.5 8.82344 1.5C9.55138 1.5 10.147 2.09559 10.147 2.82353C10.147 3.55147 9.55138 4.14706 8.82344 4.14706C8.0955 4.14706 7.49991 3.56471 7.49991 2.82353Z'
                                  fill='#707070'
                                />
                              </svg>
                            </button>

                            <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
                              <li className='dropdown-item'>
                                <Link to={`/appraisal-log/${data.id}`}>View Details</Link>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      ))}

                    {loading === false && appraisal?.length === 0 && (
                      <tr>
                        <td colSpan={8} className='text-center'>
                          No appraisal found
                        </td>
                      </tr>
                    )}
                    {loading === true && appraisal?.length === 0 && (
                      <tr>
                        <td colSpan={8} className='text-center'>
                          <HorizontalLoader></HorizontalLoader>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AppraisalLog
